import { useEffect } from "react";

const SITE_URL = "https://chouhantaxiservice.com";
const SITE_PUBLISHED = "2026-09-05T09:00:00+05:30";
const SITE_MODIFIED = "2026-10-23T09:00:00+05:30";
const DEFAULT_IMG = "/images/logo.png";

function upsertMeta(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

export default function Seo({ title, description, path = "", image = DEFAULT_IMG, type = "website", jsonLd, robots = "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1", published = SITE_PUBLISHED, modified = SITE_MODIFIED }) {
  useEffect(() => {
    const url = `${SITE_URL}${path}`;
    const img = image?.startsWith("/") ? `${SITE_URL}${image}` : image;
    if (title) document.title = title;
    upsertMeta("name", "description", description);
    upsertMeta("name", "robots", robots);
    upsertMeta("name", "googlebot", robots);
    upsertLink("canonical", url);

    upsertMeta("property", "og:title", title);
    upsertMeta("property", "og:description", description);
    upsertMeta("property", "og:image", img);
    upsertMeta("property", "og:url", url);
    upsertMeta("property", "og:type", type);
    upsertMeta("property", "og:site_name", "Chouhan Taxi Service");
    upsertMeta("property", "article:published_time", published);
    upsertMeta("property", "article:modified_time", modified);
    upsertMeta("property", "og:updated_time", modified);
    upsertMeta("name", "date", published);
    upsertMeta("name", "last-modified", modified);

    upsertMeta("name", "twitter:card", "summary_large_image");
    upsertMeta("name", "twitter:title", title);
    upsertMeta("name", "twitter:description", description);
    upsertMeta("name", "twitter:image", img);

    const scriptId = "seo-jsonld";
    const existing = document.getElementById(scriptId);
    if (existing) existing.remove();
    if (jsonLd) {
      const s = document.createElement("script");
      s.type = "application/ld+json";
      s.id = scriptId;
      s.text = JSON.stringify({ datePublished: published, dateModified: modified, ...jsonLd });
      document.head.appendChild(s);
    }
  }, [title, description, path, image, type, jsonLd, robots, published, modified]);

  return null;
}
